<template>
<div class="quiz-container">
    <van-tabs v-model="active" color="#FEDA6A">
        <van-tab title="处理中">
            <ul slot="default" class="unhanle-list">
                <li v-for="item in quizUnfinishedList" class="unhandle" @click="toQuizDetail(item.num, 'none')">
                    <div class="quiz-icon">
                        <img src="../../assets/images/quizlist.png" alt />
                    </div>
                    <div class="content">
                        <p class="title">
                            <!-- <i
                  :style="{color: 'red',fontWeight:'bold', display: item.new_msg_amount === '0' ? 'none' : 'block'}"
                >【新回复】</i> -->
                            <i style="color: #D0021B;fontWeight:bold">{{item.new_msg_amount !== '0' ? '【新回复】' : ''}}</i>
                            {{item.title}}
                        </p>
                        <p class="time">创建：{{item.create_time}}</p>
                    </div>
                    <van-icon name="arrow" class="arrow" />
                </li>
            </ul>
        </van-tab>
        <van-tab title="已完成">
            <ul slot="default" class="unhanle-list">
                <li v-for="item in quizFinishedList" class="unhandle" @click="toQuizDetail(item.num, 'done')">
                    <div class="quiz-icon">
                        <img src="../../assets/images/quizlistfinished.png" alt />
                    </div>
                    <div class="content">
                        <p class="title">{{item.title}}</p>
                        <p class="time">创建：{{item.create_time}}</p>
                    </div>
                    <div class="evaluate" v-if="item.is_assess === '1'" @click.stop="showEvaluate(item.num)">
                        评价
                    </div>
                    <van-icon name="arrow" class="arrow" />
                </li>
            </ul>
        </van-tab>
    </van-tabs>
    <!-- <van-dialog v-model="isShowEvaluate" title="标题" show-cancel-button> -->
        <evaluate v-model="isShowEvaluate" v-if="isShowEvaluate" :currentNum="currentNum" @refresh="initQuizList"></evaluate>
    <!-- </van-dialog> -->
</div>
</template>

<script>
import {
    Tab,
    Tabs,
    Icon,
    Dialog
} from "vant";
import fetchData from "@/utils/fetch";
import evaluate from './evaluate';
export default {
    data() {
        return {
            active: 2,
            isShowEvaluate: false,
            quizUnfinishedList: [],
            quizFinishedList: [],
            currentNum: '',
        };
    },
    components: {
        "van-tab": Tab,
        "van-tabs": Tabs,
        "van-icon": Icon,
        "van-dialog": Dialog,
        evaluate,
    },
    created() {
        this.initQuizList();
    },
    methods: {
        initQuizList() {
            fetchData("getFormQuestionList", { start: 0, limit: 100})
                .then(result => {
                    this.quizUnfinishedList = result.data.list.filter(item => item.status_h5 === '0');
                    this.quizFinishedList = result.data.list.filter(item => item.status_h5 === '1');
                })
                .catch(err => {});
        },
        showEvaluate(num) {
          this.isShowEvaluate = true;
          this.currentNum = num;
        },
        toQuizDetail(num, status) {
            this.$router.push({
                name: 'QuizDetail',
                query: {
                    status: status,
                    num,
                }
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.quiz-container {
    background: #f4f4f4;
    min-height: 100vh;

    .unhanle-list {
        .unhandle {
            height: 146px;
            padding: 38px 26px 28px 28px;
            box-sizing: border-box;
            background: white;
            margin-top: 20px;
            display: flex;
            align-items: center;

            // justify-content: space-between;
            .quiz-icon {
                height: 68px;
                width: 68px;
                margin-right: 20px;
            }

            .content {
                width: 320px;

                .title {
                    font-weight: bold;
                    margin-bottom: 16px;
                    font-size: 28px;
                    white-space: nowrap;
                }

                .time {
                    font-size: 24px;
                    color: #999090;
                    white-space: nowrap;
                }
            }

            .evaluate {
                color: #D0021B;
                font-size: 28px;
                margin-left: 156px;
                white-space: nowrap;
            }

            .arrow {
                margin-left: auto;
                width: 24px;
                height: 30px;
                font-size: 32px;
            }
        }
    }
}
</style>
